(function () {
  function initReadMore(root) {
    const containers = root.querySelectorAll('[data-readmore]');
    if (!containers.length) return;

    containers.forEach((container) => {
      const openLabel = container.getAttribute('data-open-label') || 'Read less';
      const closeLabel = container.getAttribute('data-close-label') || 'Read more';

      // Guard against double-binding
      if (container.__rrBound) return;
      container.__rrBound = true;

      container.addEventListener('click', function (e) {
        const btn = e.target.closest('[data-readmore-toggle]');
        if (!btn) return;

        e.preventDefault();

        const full = container.querySelector('[data-readmore-full]');
        const preview = container.querySelector('[data-readmore-preview]');
        const isOpen = !full.hasAttribute('hidden');

        if (isOpen) {
          full.setAttribute('hidden', '');
          preview.hidden = false;
          container.querySelectorAll('[data-readmore-toggle]').forEach((b) => {
            b.setAttribute('aria-expanded', 'false');
            b.textContent = closeLabel;
          });
        } else {
          full.removeAttribute('hidden');
          preview.hidden = true;
          container.querySelectorAll('[data-readmore-toggle]').forEach((b) => {
            b.setAttribute('aria-expanded', 'true');
            b.textContent = openLabel;
          });
        }
      }, { passive: false });
    });
  }

  // Run on first load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReadMore(document); });
  } else {
    initReadMore(document);
  }

  // Re-init when Shopify dynamically reloads sections (filters/sort/pagination)
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target) initReadMore(evt.target);
  });
  document.addEventListener('shopify:section:select', function (evt) {
    if (evt.target) initReadMore(evt.target);
  });
})();
